webpackJsonp([7],{

/***/ 35:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(0);
__webpack_require__(36);
__webpack_require__(1);
module.exports = __webpack_require__(37);


/***/ }),

/***/ 36:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 37:
/***/ (function(module, exports) {

/*
参数:
url: 播放地址
playerId: vido标签的id

注意：
Chrome 66之后的版本已经禁用了自动播放功能
* */

window.startPlay = function (url, playerId) {
  var options = {
    'width': '100%',
    'height': '100%',
    'fluid': false,
    'language': 'zh-CN',
    'controls': true,
    'autoplay': true,
    'loop': false,
    'muted': false,
    'sources': [],
    'notSupportedMessage':'视频无法播放请联系管理员'
  };

  if (_.endsWith(url, '.m3u8')) {
    // options['techOrder'] = ['html5', 'flash'];
    // options['flash'] = {
    //     params: {
    //         wmode: 'Opaque'
    //     },
    //     swf: '/videojs/video-js.swf'
    // };
    options.sources = [
      {
        type: 'application/x-mpegURL',
        src: url
      }
    ];
  } else {
    if (_.startsWith(url, 'rtmp://')) {
      options['techOrder'] = ['html5', 'flash'];
      options['flash'] = {
        params: {
          wmode: 'Opaque'
        },
        swf: '/videojs/video-js.swf'
      };
      options.sources = [
        {
          type: 'rtmp/mp4',
          src: url
        }
      ];
    } else {
      options.sources = [
        {
          type: 'video/mp4',
          src: url
        }
      ];
    }
  }


  /* 请求m3u8文件时 避免缓存导致每一次获取的文件都是同一个 */
  videojs.Hls.xhr.beforeRequest = function (options) {
    options.uri = updateQueryStringParameter(options.uri, '_t', new Date().valueOf());
    return options;
  };

  var player = videojs(playerId, options);

  player.ready(function () {
  });
};

function updateQueryStringParameter(uri, key, value) {
  var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
  var separator = uri.indexOf('?') !== -1 ? '&' : '?';
  if (uri.match(re)) {
    return uri.replace(re, '$1' + key + '=' + value + '$2');
  } else {
    return uri + separator + key + '=' + value;
  }
}

/***/ })

},[35]);


// WEBPACK FOOTER //
// js/playerc06253.js